import { ref } from 'vue';
import { normalizePolicy } from './config';
import type { TypographyPreset } from './types';
import { normalizeColorPickerMode, normalizeBrandPalette, type BrandColor, type ColorPickerMode } from '@shared/brandPalette';

export const typographyPolicy = ref(normalizePolicy(null));
export const typographyPresets = ref<TypographyPreset[]>([]);
export const typographyBrandPalette = ref<BrandColor[]>([]);
export const typographyColorPickerMode = ref<ColorPickerMode>('system');

export function setTypographyPolicy(raw: unknown): void {
  typographyPolicy.value = normalizePolicy(raw);
}

export function setTypographyPresets(raw: unknown): void {
  if (!Array.isArray(raw)) { typographyPresets.value = []; return; }
  typographyPresets.value = raw.filter((entry) => entry && typeof entry === 'object').map((entry) => {
    const row = entry as Record<string, unknown>;
    return {
      id: String(row.id ?? row.slug ?? ''), title: String(row.title ?? 'Typography Preset'),
      category: ['layout', 'badge', 'style'].includes(String(row.category)) ? row.category as TypographyPreset['category'] : 'layout',
      kind: row.kind === 'badge' ? 'badge' : 'text', published: row.published !== false, sortOrder: Number(row.sortOrder ?? 0),
      config: (row.config && typeof row.config === 'object' ? row.config : {}) as TypographyPreset['config'],
    };
  });
}

export function setTypographyBrandPalette(raw: unknown, pickerMode: unknown): void {
  typographyColorPickerMode.value = normalizeColorPickerMode(pickerMode);
  typographyBrandPalette.value = typographyColorPickerMode.value === 'library'
    ? normalizeBrandPalette(raw)
    : [];
}
